/**
 * TODO Rename numberPattner to NUMBER_PATTERN and put the number pattern on the top to make it a property of the class instead of recreating it every time in animate
 */

import CA_Animation from "./CA_Animation.js";

/**
 * Will increase numbers from 0 to their original value with an animation.
 *
 * @since 1.1.0
 */
export default class CA_NumbersAnimation extends CA_Animation {
  constructor(config) {
    super("numbers-animation", config);
    this.duration = this.config.duration;
  }

  /**
   * This function is necessary for the Animator, it gets called if the HTMLElement is intersecting
   *
   * @since 1.1.0
   *
   * @author Alexander Uhlemann
   *
   * @param { HTMLElement } element The element which intersects and should be animated
   * @param { string } scrollDirection Contains the direction the user was scrolling when the element got intersected. Is either "down" or "up".
   *
   * @returns { void }
   */
  animate = (element, scrollDirection) => {
    const originalText = element.dataset.caText;
    const lang = element.dataset.caLang; 

    if (element.dataset.caDuration) this.duration = element.dataset.caDuration;

    if (!originalText || !lang) return;

    const numberPattern = /[,\.\d]+/;
    const match = originalText.match(numberPattern);

    if (!match) return;

    /**
     * Get the number from the match
     */
    let numberAsText = match[0];

    /**
     * Setup the string before parsing it to a real number
     */
    if (lang == "de") {
      numberAsText = numberAsText.replace(".", "").replace(",", ".");
    } else {
      numberAsText = numberAsText.replace(",", "");
    }

    // Convert the number which is a text to an actual number
    let number = parseFloat(numberAsText);
    console.log('number', number);

    // Check if the number is an Integer or an decimal
    let numberIsInteger = Number.isInteger(number);

    /**
     * get the decimal places of the number, f.e.: 
     * 1 => 0; 
     * 1.2 => 1; 
     * 1.23 => 2; 
     * 1.234 => 3
     */
    let decimalPlaces = number.toString().split(".")[1]?.length || 2;

    let formatting = { minimumFractionDigits: numberIsInteger ? 0 : decimalPlaces, maximumFractionDigits: numberIsInteger ? 0 : decimalPlaces };

    let currentNumber = 0;
    const startTime = performance.now();
    requestAnimationFrame(() => this.animateNumber(startTime, currentNumber, this.duration, number, lang, formatting, element, originalText, numberPattern));
  };

  /**
   * The actual animation happens here.
   * Gets called each time the browser is ready to rerender, using the requestAnimationFrame here
   *
   * @since 1.1.0
   *
   * @author Alexander Uhlemann
   *
   * @param { number } startTime The performance.now() time
   * @param { number } currentNumber The number we are increasing to make an animation from 0 to number
   * @param { number } duration The duration of the animation
   * @param { number } number The actual number to animate, the goal of this animation
   * @param { string } lang The language we need to format the displayed number in the right format
   * @param { object } formatting The formatting, if the number is float, show decimal, else not
   * @param { HTMLElement } element The element which intersects and should be animated
   * @param { string } originalText The original inner text of the html element
   * @param { string } numberPattern The pattern to find the number inside the original text
   *
   * @returns { void }
   */
  animateNumber(startTime, currentNumber, duration, number, lang, formatting, element, originalText, numberPattern) {
    // The time when navigation has started in window / page began to load
    const now = performance.now();

    // Get the progress by substracting the start of the call of this animation function and the now created time / duration
    const progress = Math.min((now - startTime) / duration, 1);
    // currentNumber = Math.min(number * progress, number);
    currentNumber = number * progress;

    // Formats the  number before giving it to the element
    const formatted = currentNumber.toLocaleString(lang, formatting);

    // Write the formatted number to the element
    element.innerText = originalText.replace(numberPattern, formatted);

    // If the animation is not completed, run the animateNumber function again
    if (progress < 1) {
      requestAnimationFrame(() => this.animateNumber(startTime, currentNumber, duration, number, lang, formatting, element, originalText, numberPattern));
    }
  }
}
